"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackerResizeHandle = exports.TRACKER_RESIZE_HANDLE_LABEL = exports.MIN_TRACKER_HEIGHT = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var MIN_TRACKER_HEIGHT = exports.MIN_TRACKER_HEIGHT = 200;
var TRACKER_RESIZE_HANDLE_LABEL = exports.TRACKER_RESIZE_HANDLE_LABEL = "Drag to resize the panel";
var clampTrackerHeight = function clampTrackerHeight(height, maxHeight) {
  return Math.min(maxHeight, Math.max(MIN_TRACKER_HEIGHT, Math.round(height)));
};
var TrackerResizeHandle = exports.TrackerResizeHandle = function TrackerResizeHandle(_ref) {
  var height = _ref.height,
    maxHeight = _ref.maxHeight,
    defaultHeight = _ref.defaultHeight,
    onResize = _ref.onResize;
  var dragStartRef = (0, _react.useRef)(null);
  function onPointerDown(event) {
    event.preventDefault();
    event.currentTarget.setPointerCapture(event.pointerId);
    dragStartRef.current = {
      pointerY: event.clientY,
      height: height
    };
  }
  function onPointerMove(event) {
    var dragStart = dragStartRef.current;
    if (dragStart === null) return;
    onResize(clampTrackerHeight(dragStart.height + (dragStart.pointerY - event.clientY), maxHeight));
  }
  function onPointerUp(event) {
    dragStartRef.current = null;
    event.currentTarget.releasePointerCapture(event.pointerId);
  }
  function onKeyDown(event) {
    if (event.key === "ArrowUp") onResize(clampTrackerHeight(height + 40, maxHeight));
    if (event.key === "ArrowDown") onResize(clampTrackerHeight(height - 40, maxHeight));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    role: "separator",
    "aria-orientation": "horizontal",
    "aria-label": TRACKER_RESIZE_HANDLE_LABEL,
    "aria-valuenow": height,
    "aria-valuemin": Math.min(MIN_TRACKER_HEIGHT, maxHeight),
    tabIndex: 0,
    title: "".concat(TRACKER_RESIZE_HANDLE_LABEL, ". Double-click to reset."),
    className: "flex-shrink-0 flex items-center justify-center h-[10px] -mt-1 mb-0.5 cursor-row-resize select-none touch-none group",
    onPointerDown: onPointerDown,
    onPointerMove: onPointerMove,
    onPointerUp: onPointerUp,
    onPointerCancel: onPointerUp,
    onDoubleClick: function onDoubleClick() {
      return onResize(defaultHeight);
    },
    onKeyDown: onKeyDown,
    "data-sentry-component": "TrackerResizeHandle",
    "data-sentry-source-file": "TrackerResizeHandle.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "h-[3px] w-10 rounded-full bg-[#D4D3D0] group-hover:bg-primary transition-colors"
    })
  });
};